import { atom } from 'recoil'

export const isOpenDiscardConfigState = atom({
  key: 'isOpenDiscardProspectConfigState',
  default: false
})
